import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory, useRouteMatch } from 'react-router';

const InventoryPages = () => {
  const history = useHistory();
  const match = useRouteMatch();

  useEffect(() => {
    if (match.isExact) {
      history.replace(`/app/operational/inventory/parts`);
    }
  }, [match]);

  return null;
};

InventoryPages.propTypes = {
  route: PropTypes.object.isRequired,
};

export default InventoryPages;
